export const motivosSerasaEnum = [
    //{descricaoSerasa: "SEM RISCO APARENTE", motivo: "Sem Risco Aparente", descricaoBanco: "SEM_RISCO_APARENTE"},
    {descricaoSerasa: "ALERTA DE RISCO", motivo: "Alerta de Risco", descricaoBanco: "ALERTA_RISCO"},
    {descricaoSerasa: "COM RISCO", motivo: "Com Risco", descricaoBanco: "COM_RISCO"},
    {descricaoSerasa: "NÃO PASSÍVEL DE ANÁLISE", motivo: "Não Passível de Análise", descricaoBanco: "NAO_PASSIVEL"},
    {descricaoSerasa: "AUSENTE", motivo: "AUSENTE", descricaoBanco: "AUSENTE"}
]